module.exports = __webpack_public_path__ + "img/social-new-2.c9da931.jpg";